import { useSelector, useDispatch } from 'react-redux';

// Store
import { selectBranch, selectCashRegister, selectPv } from '../../stores/mainStore/actions';

export const ClearUserToken = () => localStorage.removeItem("x-user");
export const getUserFromLocalStorage = () => {
    const data = localStorage.getItem("x-user");
    if(!data) return;

    return JSON.parse(data) || {};
};
const saveUserInLocalStorage = (data) => 
    localStorage.setItem("x-user", JSON.stringify(data));

const useUser = () => {
    const { user, business, branch, pv, cashRegister } = useSelector(store =>  store.main.configuration);
    const dispatch = useDispatch();

    const SelectBranch = (business, branch, pv, cashRegister) => {
        const saved = getUserFromLocalStorage();
        saveUserInLocalStorage({ ...saved, business, branch, pv, cashRegister });
        dispatch(selectBranch(business, branch, pv, cashRegister));
    }

    const SelectPv = (pv) => {
        const saved = getUserFromLocalStorage();
        saveUserInLocalStorage({ ...saved, pv });
        dispatch(selectPv(pv));
    }

    const SelectCashRegister = (cashRegister) => {
        const saved = getUserFromLocalStorage();
        saveUserInLocalStorage({ ...saved, cashRegister });
        dispatch(selectCashRegister(cashRegister));
    }

    return {
        ...user,
        business,
        branch,
        pv,
        cashRegister,
        SelectBranch,
        SelectCashRegister,
        SelectPv
    };
}

export default useUser;